import {
	FILE_MAX_SIZE_ERROR,
	FILE_TYPE_ERROR,
	MAX_FILE_SIZE_BYTES,
	SUPPORTED_FILE_MIME
} from '@shared/model/file-upload';

export const validateFile = (file: File) => {
	if ((file?.size ?? 0) > MAX_FILE_SIZE_BYTES) {
		return FILE_MAX_SIZE_ERROR;
	}

	if (file && !SUPPORTED_FILE_MIME.includes(file.type)) {
		return FILE_TYPE_ERROR;
	}

	return null;
};
